export interface AuthTokens {
  accessToken: string;
  refreshToken: string;
  expiredAt: string;
}

const STORAGE_KEY = 'authTokens';

export const storage = {
  getTokens(): AuthTokens | null {
    try {
      const tokens = localStorage.getItem(STORAGE_KEY);
      if (!tokens) return null;
      return JSON.parse(tokens) as AuthTokens;
    } catch {
      return null;
    }
  },

  setTokens(tokens: AuthTokens): void {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(tokens));
  },

  clearTokens(): void {
    localStorage.removeItem(STORAGE_KEY);
  },

  isTokenExpired(): boolean {
    const tokens = this.getTokens();
    if (!tokens) return true;

    const expiryDate = new Date(tokens.expiredAt);
    const now = new Date();
    return now >= expiryDate;
  },
};
